<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Matrizes</h4>
          <router-link to="/app/matriz">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData.filter(data => !search || 
            data.name.toLowerCase().includes(search.toLowerCase()) )">
            <el-table-column label="ID" min-width="80" prop="id" sortable/>
            <el-table-column label="Nome" min-width="250" prop="name" sortable/>
            <el-table-column label="Filiais" min-width="250" prop="filiais" sortable/>
            <el-table-column label="Ações">
              <div class="td-actions" slot-scope="props">
                <a
                  v-tooltip.top-center="'Edit Profile'"
                  class="btn btn-warning btn-link btn-xs"
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  v-tooltip.top-center="'Delete'"
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      companyList: [],
      search: ''
    };
  },
  computed: {
    tableData() {
      // console.log('store', this.$store.state.parent.matrizes)
      const companies = this.$store.state.parent.matrizes

      const dateConverted = companies.map(v => {
        let filiais =''
         for (let index = 0; index < v.branch_companies.length; index++) {
           filiais = filiais + '-' + v.branch_companies[index].name
         }
        return { ...v, filiais };
      })
      return dateConverted
    },
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.getListCompany()
    this.getData()
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  methods: {
    getData() {
      this.$store.dispatch("parent/list").catch(err => console.log(err))
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/matriz/${row.id}`);
    },
    getListCompany () {
      this.$store.dispatch('general/listUser').then(()=> {
        var x = this.$store.state.general.listUser.user_list_info
        this.companyList = x.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
          ))
        )
        console.log('store', this.$store.state)
      })
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = row.name;
      swal.fire({       
        title: "Atenção",
        text: `Você está prestes a excluir a conta da empresa ${itemName} .
          Todos os dados associados serão excluídos permanentemente sem possibilidade
          de recuperação.
          Confirmando esta ação, o e-mail ${row.email} receberá um token
          que deverá ser usado para confirmar a exclusão.
          
          Em caso de dúvidas, consulte suporte SmartMach.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Desejo excluir!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("parent/delete", { id: row.id });
          swal.fire({
            title: 'Insira o Token recebido',
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Deletar!',
            cancelButtonClass: "btn btn-danger btn-fill",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: (token) => {
              this.$store.dispatch("parent/valideToken", {id: row.id, item: {token: token}}).then(resp =>{
                console.log('res', resp)
                if (resp.status === 200) {
                  swal.fire({
                    title: "Pedido enviado",
                    text: `Foi solicitado a exclusão da ${itemName}, a confirmação chegará por e-mail. `,
                    icon: "warning",
                    confirmButtonClass: "btn btn-info btn-fill",
                    buttonsStyling: false
                  });
                } else if (resp.status === 404) {
                  swal.fire({
                    title: "Token inválido",
                    text: `Token não confere, favor repita o procedimento. `,
                    icon: "error",
                    confirmButtonClass: "btn btn-info btn-fill",
                    buttonsStyling: false
                  });

                } else if (resp.status === 400) {
                  swal.fire({
                    title: "Token inválido",
                    text: `Token inserido já venceu.`,
                    icon: "error",
                    confirmButtonClass: "btn btn-info btn-fill",
                    buttonsStyling: false
                  });

                } else {
                  swal.fire({
                    title: "Algo deu errado",
                    text: `Favor entrar em contato com suporte SmartMach `,
                    icon: "error",
                    confirmButtonClass: "btn btn-info btn-fill",
                    buttonsStyling: false
                  });

                }
              })
            }
          });
          this.getData()
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluída.`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
